'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var makeStyles$2 = require('../../node_modules/@material-ui/core/styles/makeStyles.js');

var makeStyles = makeStyles$2;

exports["default"] = makeStyles;
